var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main-footer no-print"},[_c('strong',[_vm._v(" Copyright © 2020 "),_c('a',{attrs:{"href":"https://www.boradelivery.com.br"}},[_vm._v("Bora Delivery")]),_vm._v(". ")]),_vm._v(" Todos os direitos reservados. ")])
}]

export { render, staticRenderFns }